import { BreakPoints, Loader } from '@kanda-libs/ks-design-library';
import { Form } from '@kanda-libs/ks-component-ts';

import Container from './Request-container';
import Mobile from './Mobile';
import Desktop from './Desktop';

import { Helmet } from '../../../components';

const ViewComponent = ({}) => (
  <Container>
    {({ onSubmit, form, isSubmitting, ...restProps }) => (
      <>
        <Helmet title="Forgot Password" />
        <Form id="forgot-password-request" form={form} onSubmit={onSubmit}>
          <BreakPoints
            mobile={<Mobile {...restProps} />}
            desktop={<Desktop {...restProps} />}
          />
          <Loader isLoading={isSubmitting} />
        </Form>
      </>
    )}
  </Container>
);

ViewComponent.displayName = 'ForgotPassword-Request-view';

export default ViewComponent;
